import { useState, useEffect, useCallback } from 'react';
import { fetchUsers, fetchDepartments } from '../api';
import { User, DepartmentRead } from '../types';

export const useAccess = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [departments, setDepartments] = useState<DepartmentRead[]>([]);

  const [loading, setLoading] = useState<boolean>(true);
  const [page, setPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);

  const loadData = useCallback(async (currentPage: number) => {
    setLoading(true);
    try {
      const [usersRes, depsRes] = await Promise.all([
        fetchUsers(currentPage, 20),
        // Департаменты загружаем один раз, если они уже есть - можно не перезагружать,
        // но для простоты грузим параллельно или проверяем стейт
        fetchDepartments()
      ]);

      setUsers(usersRes.items);
      setTotalPages(usersRes.pages);
      setDepartments(depsRes);
    } catch (error) {
      console.error("Ошибка при загрузке данных:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadData(page);
  }, [page, loadData]);

  return {
    users,
    departments,
    loading,
    page,
    setPage,
    totalPages,
    refreshUsers: () => loadData(page)
  };
};